export const IMPORT_SAMPLE_LEAD = [
    {
      "title": "Mr.",
      "contactFirstName": "John",
      "contactMiddleName": "A",
      "contactLastName": "Doe",
      "contactemailwork": "john.doe@company.com",
      "contactphonework": "+1-555-1234",
      "businessName": "Doe Industries",
      "accountTypesName": "Business",
      "currentStage": "Prospect",
      "addressTypeId": "Billing",
      "addressClassId": "Commercial",
      "streetAddress1": "123 Main St",
      "streetAddress2": "Suite 100",
      "country": "USA",
      "state": "CA",
      "city": "Los Angeles",
      "zipcode": "90001",
      "addressName": "Doe Industries HQ",
      "leadTypesName": "Premium, Prospect",
      "tags": "Gold, Silver",
    },
    {
      "title": "Ms.",
      "contactFirstName": "Jane",
      "contactMiddleName": "B",
      "contactLastName": "Smith",
      "contactemailwork": "jane.smith@services.com",
      "contactphonework": "+44-20-7946-0958",
      "businessName": "Smith Consulting",
      "accountTypesName": "Consulting",
      "currentStage": "Prospect",
      "addressTypeId": "Billing",
      "addressClassId": "Commercial",
      "streetAddress1": "456 Queen St",
      "streetAddress2": "Suite 200",
      "country": "United Kingdom",
      "state": "England",
      "city": "London",
      "zipcode": "SW1A 1AA",
      "addressName": "Smith Consulting London Office",
      "leadTypesName": "Premium, Prospect",
      "tags": "Gold, Silver",
    },
    {
      "title": "Dr.",
      "contactFirstName": "Emily",
      "contactMiddleName": "C",
      "contactLastName": "Johnson",
      "contactemailwork": "emily.johnson@health.org",
      "contactphonework": "+61-2-1234-5678",
      "businessName": "Johnson Healthcare",
      "accountTypesName": "Healthcare",
      "currentStage": "Prospect",
      "addressTypeId": "Billing",
      "addressClassId": "Commercial",
      "streetAddress1": "789 King St",
      "streetAddress2": "Floor 3",
      "country": "Australia",
      "state": "NSW",
      "city": "Sydney",
      "zipcode": "2000",
      "addressName": "Johnson Healthcare Sydney Office",
      "leadTypesName": "Premium, Prospect",
      "tags": "Gold, Silver",
    }
  ];
